export const globalTrackerAPIRoot = 'https://graphics.thomsonreuters.com/data/2020/coronavirus/global-tracker';
export const globalTrackerAPI = 'https://graphics.thomsonreuters.com/data/2020/coronavirus/tracking/global/data.json';

export const oxfordStringencyAPIRoot = 'https://graphics.thomsonreuters.com/data/2020/coronavirus/oxford-covid-stringency-tracker';

export const globalTopojsonURL = 'https://cdn.jsdelivr.net/npm/@reuters-graphics/graphics-atlas-client@0.5.2/topojson/custom/world.json';
